// extracted by mini-css-extract-plugin
export default {"link_box":"Property_link_box__e+1ho","minhight":"Property_minhight__bt0W1"};